<svelte:options accessors/>
<script lang="ts">
    import NauiFilters from "../naui/components/NauiFilters.svelte";
    import NauiButton from "../naui/atoms/NauiButton.svelte";
    import type {ICodificacion} from "../interfaces/codificacion.interface";
    import type {IProduct} from "../interfaces/product.interface";
    import {createEventDispatcher} from "svelte";
    import LoadingBar from "./components/modals/LoadingBar.svelte";
    import NauiSearcher from "../naui/components/NauiSearcher.svelte";
    import FindProducts from "./components/FindProducts.svelte";
    import NauiFloatingAction from "../naui/components/NauiFloatingAction.svelte";

    export let list: Array<ICodificacion> = [];
    export let filters = [];
    export let products: Array<IProduct> = [];
    export let cmptProducts: any;

    export let encode: boolean = false;
    export let editable: boolean = false;
    export let isBusinessGroup: boolean = false;
    export let isCodified: boolean = false;
    export let loading: boolean = false;


    let dispatch = createEventDispatcher();
    let selectedItem: any;

    let term: string = '';
    let currentFilters: any;

    export function updateItem(item) {
        const index = list.findIndex(i => i.slug === item.slug);
        if (index >= 0 && index < list.length) {
            list[index] = item;
            list = [...list];
            console.log('listed');
        }
        selectedItem = null;
    }

    function edit(slug) {
        selectedItem = list.find(c => c.slug === slug);
        if (selectedItem) {
            for (let i = 0; i < products.length; i++) {
                products[i].selected = selectedItem?.product?.id === products[i].id;
            }
            products = [...products];
            cmptProducts ? cmptProducts.setOpen(true) : console.error('cmptProduct not exist');
        }
    }

    function setProductToItem(evt) {
        const {product} = evt.detail || {product: null}
        if (selectedItem) {
            dispatch('setProduct', {
                'item': selectedItem.id,
                'product': product
            });
        }
    }

    function removeProduct(item) {
        if (confirm('¿Estás seguro de que deseas quitar el producto de este ítem?')) {
            dispatch('setProduct', {
                'item': item.id,
                'product': null
            });
        }
    }

    function filter(evt) {
        currentFilters = evt.detail;
        dispatch('filtered', {
            term,
            ...currentFilters
        })
    }

    function search(evt) {
        term = (evt.detail || {term: ''}).term
        dispatch('filtered', {
            term,
            ...currentFilters
        })
    }

    function save() {
        dispatch('update', {
            list: list.map((i: any) => ({
                id: i.id,
                roof: i.roof
            }))
        });
    }
</script>
<div class="box-l sx-ii mb-1">
    <NauiSearcher on:search={search}/>
    <NauiFilters {filters}
                 on:filtered={filter}/>

    {#if !loading}
        <div class="radius py-ii px-1 back-gray"><strong class="mr-i">{list?.length || 0}</strong>Items</div>
    {/if}
</div>
{#if !loading}
    <table class="naui-table w-100">
        <thead>
        <tr>
            <th>
                <div>Item</div>
            </th>
            <th>
                <div>Grupo</div>
            </th>
            <th>
                <div>Código cliente</div>
            </th>
            <th>
                <div>Nombre solicitado por el cliente</div>
            </th>
            <th>
                <div>Código | Descripción B.BRAUN</div>
            </th>
            <th>
                <div>Cantidad</div>
            </th>
            <th>
                <div>Precio techo</div>
            </th>
            <th>
                <div>Codificado</div>
            </th>
        </tr>
        </thead>
        <tbody>
        {#each list as item, index (item.slug)}
            <tr class="{selectedItem?.slug === item.slug ? 'item-selected': ''}">
                <td>
                    <div>
                        {item?.number ? item.number : ''}
                    </div>
                </td>
                <td>
                    <div>
                        <input bind:value={item.group}
                               readonly={!editable}
                               type="text"
                               class="naui-input self-start"
                               style="width: 150px">
                    </div>
                </td>
                <td>
                    <div>
                        <input bind:value={item.code}
                               readonly={!editable}
                               type="text"
                               class="naui-input self-start"
                               style="width: 150px">
                    </div>
                </td>
                <td>
                    <div class="py-ii">
                    <textarea bind:value={item.name}
                              readonly={!editable}
                              name=""
                              style="min-height: 70px"
                              rows="3"
                              class="naui-input w-100 self-start"></textarea>
                    </div>
                </td>
                <td>
                    <div class="py-ii">
                        {#if encode}
                        <div >
                            <textarea style="min-height: 70px"
                                        rows="3"
                                        class="naui-input pointer w-100  self-start"
                                        disabled>{item.product ? item.product.label : ''}
                            </textarea>
                            <button on:click={edit.bind(this, item.slug)}>
                                CODIFICAR
                            </button>
                            {#if item.product}
                                <button class="btn-remove"
                                        on:click={() => removeProduct(item)}>
                                    QUITAR PRODUCTO
                                </button>
                            {/if}
                        </div>

                        {:else}
                        <textarea style="min-height: 70px"
                                  class="naui-input pointer w-100  self-start"
                                  rows="3"
                                  disabled>{item.product ? item.product.label : ''}</textarea>
                        {/if}

                    </div>
                </td>
                <td>
                    <div>
                        <input type="number"
                               readonly
                               bind:value={item.quantity}
                               class="naui-input self-start"
                               style="width: 100px">
                    </div>
                </td>
                <td>
                    <div>
                        <input type="number"
                               readonly="{!editable}"
                               bind:value={item.roof}
                               class="naui-input self-start"
                               style="width: 100px">
                    </div>
                </td>
                <td>
                    <div class="box">
                        {#if item.encoded}
                            <i class=" mt-ii fa fa-circle self-start" style="color: #3F9C35; font-size: 1.3rem"></i>
                        {/if}
                    </div>
                </td>
            </tr>
        {/each}
        </tbody>
    </table>
{:else}
    <div class="text-c">
        <LoadingBar/>
    </div>
{/if}

{#if isCodified && isBusinessGroup}
    <div class="box-r mt-2">
        <NauiButton icon="save"
                    caption="DESCARGAR PLANTILLA"
                    color="accent"
                    mode="solid"
                    on:click={()=>dispatch('template')}/>
    </div>
{/if}

<FindProducts bind:this={cmptProducts}
              {products}
              on:close={()=>selectedItem = null}
              on:filterProducts
              on:setProduct={setProductToItem}/>
{#if editable}
    <NauiFloatingAction>
        <NauiButton caption="GUARDAR"
                    mode="solid"
                    icon="save"
                    color="accent"
                    on:click={()=>save()}/>
    </NauiFloatingAction>
{/if}

<style>
    td > div {
        padding: .5rem 0;
    }

    td {
        vertical-align: top;
    }

    tr.item-selected {
        background-color: var(--back-gray);
    }

    .btn-remove {
        margin-left: .5rem;
        background: none;
        border: 1px solid #d32f2f;
        color: #d32f2f;
        border-radius: 4px;
        padding: .25rem .5rem;
        cursor: pointer;
        font-size: .8rem;
    }

    .btn-remove:hover {
        background-color: #d32f2f;
        color: #fff;
    }
</style>